import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UnForm from "../../../Components/Form";

import StickyToolbar from "../../../Components/StickyToolbar";
import Table from "../../../Components/Table";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import {
    ListarDocumentoTemplateController,
    ListarModulosController,
} from "../../../Controllers/Geral/Documentos/DocumentosController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IDocumentosTemplate } from "../../../Interfaces/Geral/Documentos/DocumentosInterface";
import AtivaDesativaTemplate from "./AtivaDesativaTemplates";
import { Link } from "react-router-dom";
import "./styles.css";

export default function GestaoTemplates() {
    const {
        value: listarTemplatesResponse,
        loading: updateListLoading,
        execute: updateList,
    } = useAsyncCallback(ListarDocumentoTemplateController);

    function getListarDocumento(formData: { idModulo: number }) {
        updateList({ idTipoCaso: formData.idModulo });
    }

    function RowTable(cell: any, row: IDocumentosTemplate) {
        return (
            <>
                <div className="rowCapys">
                    <div>
                        <h4>{row.DS_DOCUMENTO}</h4>
                        <div className="StatusGrupo">
                            {row.FL_ATIVO ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    {" "}
                                    Ativo
                                </span>
                            ) : (
                                <span className="label abel-pill label-inline label-danger mr-2">
                                    {" "}
                                    Desativado
                                </span>
                            )}
                        </div>
                    </div>

                    <div className="Button-Tools">
                        <Link
                            to={`/Geral/GestaoTemplates/ConfigurarTemplates/${row.ID_DOCUMENTO_TEMPLATE}`}
                            className="btn btn-outline-primary font-weight-bold mr-2"
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                        </Link>

                        <AtivaDesativaTemplate
                            row={row}
                            ID_DOCUMENTO_TEMPLATE={row.ID_DOCUMENTO_TEMPLATE}
                            FL_ATIVO={row.FL_ATIVO}
                            then={updateList}
                        />
                    </div>
                </div>
            </>
        );
    }

    const ColunsUser = [
        {
            dataField: "DS_DOCUMENTO",
            text: "Descrição",
            formatter: RowTable,
            sort: true,
        },
    ];

    return (
        <>
            <div className="card card-custom">
                <div className="card-header card-header-tabs-line d-flex align-items-center">
                    <h3 className="card-title align-items-start ">
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            Gestão de Templates
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <Link
                            to={`/Geral/GestaoTemplates/ConfigurarTemplates/0`}
                            className="btn btn-primary font-weight-bold mr-2 linkSemIcone"
                        >
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            Cadastrar Template
                        </Link>
                    </div>
                </div>
                <div className="card-body">
                    {listarTemplatesResponse && (
                        <Table
                            data={listarTemplatesResponse}
                            loading={updateListLoading}
                            bordered={false}
                            striped={true}
                            columns={ColunsUser}
                            keyField="ID_DOCUMENTO_TEMPLATE"
                            center
                        />
                    )}
                </div>
            </div>
            <StickyToolbar inicialyOpenned={true}>
                <UnForm handleSubmit={getListarDocumento}>
                    <div className="form-group row">
                        <div className="col-12">
                            <UnForm.LazySelect
                                label="Modulo"
                                name="idModulo"
                                controller={ListarModulosController}
                                getDS={(e) => e.DS_MODULO}
                                getKeyValue={(e) => e.ID_MODULO}
                                disabled={updateListLoading}
                                onChange={(e) => {
                                    getListarDocumento({
                                        idModulo: Number(e.target.value),
                                    });
                                }}
                            >
                                <OrSpinner
                                    loadingSize="sm"
                                    spinner="default"
                                    loading={updateListLoading}
                                >
                                    <option />
                                </OrSpinner>
                            </UnForm.LazySelect>
                        </div>
                    </div>
                </UnForm>
            </StickyToolbar>
        </>
    );
}
